import React from "react";
import ImageSlider from "../component/ImageSlider";
import { SideBar } from "../component/SideBar";
import MobileNavbar from "../component/MobileNavbar";

const HomePage = () => {
  const images = [
    "/images/homepage/01.jpg",
    "/images/homepage/02.jpg",
    "/images/homepage/03.jpg",
    "/images/homepage/04.jpg",
  ];

  return (
    <>
      <MobileNavbar />
      <div className="min-h-screen bg-white font-sans text-gray-700 flex justify-center lg:pt-24 sm:pt-5 md:pt-10 pt-5 gap-40">
        <SideBar />
        <div className="w-full box-border max-w-3xl lg:block lg:pb-0 lg:gap-0 md:flex md:flex-col md:justify-between md:pb-28 md:gap-5 flex flex-col justify-between pb-28 gap-5">
          <ImageSlider images={images} interval={5000} />
          <div className="flex justify-center items-end w-screen mb-10 lg:hidden">
            <div
              className="text-gray-500 max-w-[240px] align-middle"
              style={{ fontSize: '14px', textAlign: "left" }}
            >
              <span style={{ fontSize: '35px', marginRight: '5px', fontFamily: "Tangerine, serif", lineHeight: '10px' }}
              >
                A
              </span>
              <span style={{ fontStyle: 'italic' }}>
                fiercely passionate artist trained in Fine Arts from India and the USA,
                Paramita is offering a bunch of her best works through this website. Let’s
                take a trip to her creative endeavours with profound excitements.
              </span>

            </div>
          </div>
        </div>

      </div>
    </>

  );
};

export default HomePage;